import { getTopmostPageDetail } from 'utils';

const isFramed = () => getTopmostPageDetail().isFramed;

export default isFramed;
